import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { deleteTenant } from "../api";

export const useDeleteTenant = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: deleteTenant,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["TENANT"] });
      router("/tenant");
      toast.success("Success Delete Tenant");
    },
  });

  return { Delete: mutate, isPending };
};
